module.exports = __webpack_public_path__ + "news-4a753f38/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";